import { Alert } from '@cbhq/cds-web/overlays';
import { defineMessages, useIntl } from '@cbhq/i18n';

type UnsavedChangesAlertProps = {
  visible: boolean;
  onKeepEditing: () => void;
  onDiscard: () => void;
};

const messages = defineMessages({
  title: {
    id: 'Settings.unsavedChangesAlert.title',
    defaultMessage: 'You have unsaved changes',
    description: 'Title for the alert shown when leaving the Settings edit field modal',
  },
  body: {
    id: 'Settings.unsavedChangesAlert.body',
    defaultMessage: 'Your changes will be lost if you leave.',
    description: 'Body for the alert shown when leaving the Settings edit field modal',
  },
  discardChanges: {
    id: 'Settings.unsavedChangesAlert.discardChanges',
    defaultMessage: 'Discard changes',
    description: 'Button label to discard changes in the Settings edit field modal',
  },
  keepEditing: {
    id: 'Settings.unsavedChangesAlert.keepEditing',
    defaultMessage: 'Keep editing',
    description: 'Button label to continue editing a Settings field',
  },
});

export function UnsavedChangesAlert({
  visible,
  onKeepEditing,
  onDiscard,
}: UnsavedChangesAlertProps) {
  const { formatMessage } = useIntl();

  return (
    <Alert
      title={formatMessage(messages.title)}
      body={formatMessage(messages.body)}
      visible={visible}
      stacked
      onRequestClose={onKeepEditing}
      preferredActionLabel={formatMessage(messages.discardChanges)}
      onPreferredActionPress={onDiscard}
      dismissActionLabel={formatMessage(messages.keepEditing)}
      onDismissActionPress={onKeepEditing}
      actionLayout="vertical"
      testID="settings-edit-field-unsaved-changes-alert"
    />
  );
}
